import componentRoot from './PublicCopilotLayout';

export const PublicCopilotLayout = componentRoot;
